import React from 'react';

export default class ToggleButton extends React.Component {
    static defaultProps = {
        texts: ["ON", "OFF"],
        values: ["1", "0"],
        classes: ["default", "default"],
        activeValue: "1",
        callback: (val) => { console.log(val) }
    }

    constructor(props) {
        super(props);
        this.buttonClicked = this.buttonClicked.bind(this);
    }

    buttonClicked(e, value) {
        e.preventDefault()
        this.props.callback(value)
    }

    render() {
        return <div className="btn-group btn-toggle">
            {this.props.texts.map((text, index) =>
                <button
                    key={index}
                    className={'btn btn-sm btn-' +
                        (this.props.classes[index] !== undefined ? this.props.classes[index] : 'default')
                        + ' ' +
                        (this.props.activeValue === this.props.values[index] ? 'active' : '')
                    }
                    onClick={(e) => this.buttonClicked(e, this.props.values[index])}>
                    {text}
                </button>
            )}
        </div>
    }
}
